module.exports = __webpack_public_path__ + "static/image-4ed5a1ab136af4361cecc6744418dd04.png";